export const onEnterOrSpace = (callback) => (event) => {
  if (event.key === ' ' || event.key === 'Enter') {
    callback(event)
  }
}
